var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsSprite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "html5"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    fillOpacity: 0
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#FFFFFF",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1323 102.004L13.7061 7.5L106.293 7.5L97.856 101.989L59.9434 112.5L22.1323 102.004Z",
    fill: "#2D2C2C",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 104.468L90.6377 95.9738L97.8452 15.2288L60 15.2288L60 104.468Z",
    fill: "#2D2C2C",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 50.2762L44.6626 50.2762L43.605 38.4074L60 38.4074L60 26.8162L30.9375 26.8162L31.2148 29.9286L34.061 61.8674L60 61.8674L60 50.2762ZM60 80.3774L59.9473 80.3924L47.04 76.9087L46.2148 67.6649L34.5786 67.6649L36.2026 85.8599L59.9473 92.4524L60 92.4374L60 80.3774Z",
    fill: "#EBEBEB",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.959 50.2762L59.959 61.8674L74.2314 61.8674L72.8892 76.9012L59.959 80.3887L59.959 92.4487L83.7227 85.8599L83.895 83.9024L86.6177 53.3887L86.9028 50.2762L59.959 50.2762ZM59.959 26.8162L59.959 38.4074L87.9565 38.4074L88.189 35.8049L88.7178 29.9286L88.9951 26.8162L59.959 26.8162Z",
    fill: "#EBEBEB",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "css3"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    fillOpacity: 0
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 119,
    fill: "#FFFFFF",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1326 101.154L13.71 7.4375L106.29 7.4375L97.8562 101.139L59.9436 111.562L22.1326 101.154Z",
    fill: "#2D2C2C",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 103.597L90.6375 95.174L97.845 15.1018L60 15.1018L60 103.597Z",
    fill: "#2D2C2C",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 49.0541L75.3374 49.0541L76.395 37.2842L60 37.2842L60 25.7896L89.0625 25.7896L88.7849 28.8724L85.9387 60.5487L60 60.5487L60 49.0541Z",
    fill: "#EBEBEB",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.071 78.9045L60.0186 78.9194L47.1111 75.4609L46.2861 66.2942L34.6499 66.2942L36.2737 84.3413L60.0149 90.8788L60.071 90.864L60.071 78.9045Z",
    fill: "#EBEBEB",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3513 60.0615L72.9563 75.4534L60.03 78.9119L60.03 90.8714L83.79 84.3412L83.9663 82.4001L85.98 60.0615L74.3513 60.0615Z",
    fill: "#EBEBEB",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.041 25.7896L60.041 37.2842L32.0437 37.2842L31.811 34.6997L31.2825 28.8724L31.0049 25.7896L60.041 25.7896ZM60 49.0541L60 60.5487L47.2537 60.5487L47.0212 57.9642L46.4961 52.1369L46.2188 49.0541L60 49.0541Z",
    fill: "#EBEBEB",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "react"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 101,
    fill: "white",
    fillOpacity: 0
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 101,
    fill: "#FFFFFF",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.9055 32.7026C91.7029 32.2886 90.4902 31.905 89.2686 31.5522C89.4739 30.7106 89.6626 29.8791 89.8303 29.0623C92.5837 15.6483 90.7837 4.84174 84.636 1.28369C78.7415 -2.12726 69.1016 1.42944 59.3657 9.93335C58.4062 10.7729 57.468 11.6368 56.552 12.5239C55.9387 11.934 55.3147 11.3555 54.6802 10.7888C44.4766 1.69611 34.2493 -2.13611 28.1079 1.43207C22.2188 4.8537 20.4749 15.0126 22.9536 27.7253C23.2002 28.9844 23.4788 30.2369 23.7888 31.4818C22.3411 31.8947 20.9441 32.3341 19.6072 32.8019C7.64429 36.988 0.00463867 43.5482 0.00463867 50.3528C0.00463867 57.3807 8.20605 64.4299 20.666 68.7043C21.6763 69.0494 22.6948 69.3691 23.7207 69.6633C23.3875 71.0041 23.0918 72.3539 22.8335 73.7113C20.4705 86.2034 22.3159 96.1223 28.1892 99.5222C34.2554 103.033 44.4368 99.4247 54.3506 90.7267C55.1543 90.0196 55.9404 89.2924 56.7083 88.5459C57.7002 89.5065 58.7188 90.4392 59.7625 91.3429C69.366 99.6364 78.8501 102.985 84.7175 99.5762C90.7781 96.0549 92.7478 85.3994 90.1907 72.4355C89.989 71.4199 89.7632 70.4093 89.5132 69.4047C90.228 69.192 90.9299 68.9732 91.614 68.7455C104.567 64.4384 112.995 57.4747 112.995 50.3528C112.995 43.5234 105.109 36.9189 92.9055 32.7026ZM90.0962 64.1473C89.4783 64.3524 88.8445 64.5504 88.1982 64.7432C86.7683 60.1995 84.8386 55.3683 82.4768 50.3763C84.7305 45.5035 86.5859 40.7339 87.9758 36.22C89.1318 36.5557 90.2532 36.9097 91.3347 37.2831C101.791 40.8961 108.168 46.2371 108.168 50.3528C108.168 54.7366 101.281 60.4276 90.0962 64.1473ZM85.4556 73.3764C86.5864 79.1086 86.7476 84.2915 85.9985 88.3434C85.3259 91.9843 83.9727 94.4114 82.2988 95.3838C78.7383 97.4525 71.1235 94.7636 62.9109 87.6706C61.9399 86.8304 60.9927 85.9633 60.0698 85.0703C63.2539 81.5756 66.4355 77.513 69.541 73.0008C75.0034 72.5144 80.1641 71.7188 84.8438 70.6331C85.0693 71.5425 85.2732 72.4573 85.4556 73.3764ZM38.5256 95.0263C35.0466 96.2592 32.2759 96.2946 30.6008 95.3253C27.0369 93.2623 25.5552 85.298 27.5762 74.615C27.8164 73.3526 28.0916 72.0972 28.4011 70.8501C33.0293 71.8778 38.1523 72.6167 43.6274 73.0624C46.7542 77.4775 50.0278 81.5357 53.3269 85.0893C52.6257 85.7703 51.908 86.4337 51.1743 87.0792C46.7903 90.9252 42.3972 93.6539 38.5256 95.0263ZM22.2275 64.1203C16.718 62.2301 12.168 59.7737 9.04907 57.0933C6.24658 54.6848 4.83179 52.2931 4.83179 50.3528C4.83179 46.2234 10.9656 40.9563 21.196 37.3766C22.4377 36.9424 23.7371 36.5327 25.0854 36.1482C26.4995 40.764 28.3542 45.5903 30.5925 50.4707C28.3252 55.4232 26.4441 60.3266 25.0161 64.9969C24.0796 64.7277 23.1499 64.4354 22.2275 64.1203ZM27.6909 26.7946C25.5674 15.903 26.9775 7.68701 30.5266 5.62494C34.3066 3.42859 42.6653 6.56006 51.4753 14.4115C52.0498 14.9246 52.615 15.4482 53.1707 15.9819C49.8877 19.52 46.6443 23.548 43.5454 27.9371C38.2312 28.4314 33.1445 29.2252 28.4678 30.2888C28.1794 29.131 27.9204 27.966 27.6909 26.795L27.6909 26.7946ZM76.4299 38.8738C75.3254 36.9588 74.1797 35.0679 72.9939 33.2023C76.5991 33.6599 80.0532 34.2673 83.2969 35.0097C82.3232 38.1425 81.1094 41.4175 79.6807 44.7753C78.6365 42.7866 77.5525 40.8191 76.4299 38.8738ZM56.5542 19.4442C58.7805 21.8651 61.0103 24.5677 63.2034 27.5002C58.7544 27.2894 54.2981 27.2885 49.8489 27.4976C52.0444 24.5921 54.2932 21.893 56.5542 19.4442ZM36.551 38.907C35.4424 40.8366 34.3789 42.7919 33.3611 44.7712C31.9558 41.4254 30.7532 38.1354 29.771 34.9583C32.9949 34.2345 36.4326 33.6426 40.0149 33.1935C38.8157 35.0704 37.6609 36.9753 36.551 38.9066L36.551 38.907ZM40.1177 67.8569C36.4167 67.4423 32.9272 66.881 29.7043 66.1766C30.7019 62.9429 31.9312 59.5828 33.3669 56.1652C34.3887 58.1461 35.4565 60.1025 36.5698 62.033C37.7148 64.0175 38.9004 65.9614 40.1177 67.8569ZM56.6875 81.6026C54.3994 79.1254 52.1177 76.3847 49.8892 73.4371C52.0527 73.5222 54.2583 73.5656 56.5 73.5656C58.803 73.5656 61.0796 73.5137 63.3206 73.4136C61.1201 76.4144 58.8987 79.1591 56.6875 81.6026ZM79.7261 55.9907C81.2366 59.4459 82.5095 62.7883 83.5203 65.9667C80.2444 66.717 76.7073 67.3213 72.9802 67.77C74.1746 65.8699 75.3311 63.946 76.449 61.9998C77.5857 60.0214 78.6782 58.0179 79.7261 55.9907ZM72.2678 59.5793C70.5564 62.5634 68.7485 65.4908 66.8474 68.357C63.4036 68.6018 59.9524 68.7234 56.5 68.7216C52.9836 68.7216 49.5635 68.6117 46.2698 68.3973C44.3191 65.5378 42.4768 62.6052 40.7471 59.6059L40.7476 59.6059C39.0259 56.6224 37.4175 53.5744 35.9263 50.4684C37.4138 47.3618 39.0171 44.3124 40.7329 41.3267L40.7324 41.3271C42.4475 38.3406 44.2751 35.4205 46.2112 32.5733C49.5713 32.3182 53.0171 32.1852 56.4995 32.1852L56.5 32.1852C59.9983 32.1852 63.4485 32.3195 66.8076 32.5764C68.7241 35.4194 70.54 38.3294 72.252 41.301C73.9736 44.2801 75.5981 47.3146 77.123 50.3998C75.6138 53.5165 73.9944 56.5782 72.2678 59.5793ZM82.2251 5.48053C86.0085 7.67059 87.4802 16.5023 85.103 28.0841C84.9512 28.823 84.7808 29.5756 84.5955 30.3389C79.9072 29.2527 74.8169 28.4451 69.4873 27.9432C66.3826 23.5059 63.1655 19.4717 59.936 15.9792C60.7825 15.1603 61.6489 14.3627 62.5349 13.5871C70.8767 6.30133 78.6731 3.42462 82.2251 5.48053ZM56.5 40.2263C62.0723 40.2263 66.5896 44.7602 66.5896 50.3528C66.5896 55.9455 62.0723 60.4794 56.5 60.4794C50.9277 60.4794 46.4102 55.9455 46.4102 50.3528C46.4102 44.7602 50.9277 40.2263 56.5 40.2263Z",
    fill: "#2D2C2C",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "nextjs"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#FFFFFF",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5L112.5 7.5L112.5 112.5L7.5 112.5L7.5 7.5Z",
    fill: "#2D2C2C",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("image", {
    x: 24,
    y: 24,
    width: 72,
    height: 72,
    xlinkHref: "https://cdn.simpleicons.org/nextdotjs/EBEBEB"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "vue"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#FFFFFF",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5L112.5 7.5L112.5 112.5L7.5 112.5L7.5 7.5Z",
    fill: "#2D2C2C",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("image", {
    x: 24,
    y: 24,
    width: 72,
    height: 72,
    xlinkHref: "https://cdn.simpleicons.org/vuedotjs/EBEBEB"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "tailwindcss"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#FFFFFF",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5L112.5 7.5L112.5 112.5L7.5 112.5L7.5 7.5Z",
    fill: "#2D2C2C",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("image", {
    x: 24,
    y: 24,
    width: 72,
    height: 72,
    xlinkHref: "https://cdn.simpleicons.org/tailwindcss/EBEBEB"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "javascript"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    fillOpacity: 0
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#FFFFFF",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5L112.5 7.5L112.5 112.5L7.5 112.5L7.5 7.5Z",
    fill: "#2D2C2C",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0337 89.5312C78.9285 91.3485 80.3184 92.8759 82.0435 93.9375C83.7686 94.9991 85.7583 95.5515 87.7837 95.5312C91.8713 95.5312 94.4851 93.4875 94.4851 90.6562C94.4851 87.2812 91.8 86.0737 87.3 84.105L84.8325 83.0475C77.7075 80.0137 72.9824 76.215 72.9824 68.1825C72.9824 60.7838 78.6074 55.1475 87.4312 55.1475C90.2876 54.9412 93.1416 55.5805 95.637 56.9856C98.1326 58.3907 100.159 60.4995 101.464 63.0488L93.75 67.98C93.2476 66.7159 92.3728 65.6345 91.2417 64.879C90.1104 64.1236 88.7764 63.7299 87.4163 63.75C86.8228 63.6906 86.2236 63.7554 85.6567 63.9404C85.0896 64.1254 84.5676 64.4265 84.1233 64.8245C83.6792 65.2224 83.3228 65.7085 83.0769 66.2518C82.8311 66.7951 82.7009 67.3837 82.6951 67.98C82.6951 70.9388 84.5288 72.1387 88.7625 73.98L91.23 75.0375C99.615 78.6337 104.355 82.2975 104.355 90.5363C104.355 99.42 97.3762 104.287 88.0051 104.287C84.3538 104.52 80.7129 103.691 77.5222 101.901C74.3318 100.11 71.7273 97.4342 70.0237 94.1962L78.0337 89.5312ZM43.1775 90.3862C44.7263 93.135 46.1362 95.46 49.5264 95.46C52.7664 95.46 54.8137 94.1925 54.8137 89.2612L54.8137 55.71L64.6799 55.71L64.6799 89.3925C64.6799 99.6075 58.6799 104.258 49.9463 104.258C46.8591 104.426 43.7932 103.657 41.1514 102.051C38.5095 100.444 36.4158 98.0761 35.145 95.2575L43.1775 90.3862Z",
    fill: "#EBEBEB",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "git"
  }, /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M103.02 47.82L57.17 1.98C54.53 -0.67 50.25 -0.67 47.61 1.98L38.09 11.49L50.16 23.57C52.97 22.62 56.19 23.26 58.43 25.5C60.67 27.75 61.31 30.99 60.33 33.81L71.97 45.45C74.79 44.48 78.04 45.1 80.29 47.36C83.43 50.5 83.43 55.59 80.29 58.73C77.14 61.88 72.05 61.88 68.9 58.73C66.54 56.37 65.96 52.9 67.15 49.98L56.3 39.13L56.3 67.69C57.09 68.08 57.8 68.59 58.43 69.21C61.57 72.36 61.57 77.45 58.43 80.59C55.28 83.74 50.19 83.74 47.05 80.59C43.91 77.45 43.91 72.36 47.05 69.21C47.8 68.46 48.7 67.86 49.68 67.46L49.68 38.63C48.7 38.23 47.8 37.63 47.05 36.87C44.67 34.5 44.09 31 45.31 28.08L33.41 16.17L1.98 47.6C-0.67 50.25 -0.67 54.53 1.98 57.17L47.82 103.01C50.46 105.65 54.74 105.65 57.38 103.01L103.01 57.38C105.66 54.74 105.66 50.46 103.01 47.82L103.02 47.82Z",
    fill: "#2D2C2C",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "typescript"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 52.5L0 105L52.5 105L105 105L105 52.5L105 0L52.5 0L0 0L0 52.5Z",
    fill: "#2D2C2C",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.2202 52.8481L23.1869 57.1481L30.0203 57.1481L36.8535 57.1481L36.8535 76.5648L36.8535 95.9814L41.6869 95.9814L46.5203 95.9814L46.5203 76.5648L46.5203 57.1481L53.3535 57.1481L60.1869 57.1481L60.1869 52.9314C60.1869 50.5981 60.1368 48.6481 60.0702 48.5981C60.0203 48.5315 51.7036 48.4982 41.6202 48.5148L23.2703 48.5648L23.2202 52.8481Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M84.7231 48.4432C87.3899 49.11 89.4232 50.2932 91.2898 52.2266C92.2565 53.2599 93.6898 55.1433 93.8065 55.5933C93.8398 55.7266 89.2732 58.7932 86.5065 60.5099C86.4065 60.5765 86.0065 60.1433 85.5565 59.4766C84.2065 57.5099 82.7898 56.6599 80.6232 56.5099C77.4398 56.2932 75.3899 57.96 75.4065 60.7433C75.4065 61.5599 75.5232 62.0432 75.8564 62.71C76.5565 64.1599 77.8564 65.0266 81.9398 66.7932C89.4565 70.0266 92.6732 72.1599 94.6732 75.1932C96.9065 78.5765 97.4065 83.9766 95.8899 87.9933C94.2231 92.36 90.0898 95.3265 84.2732 96.3099C82.4731 96.6266 78.2065 96.5765 76.2732 96.2266C72.0565 95.4766 68.0565 93.3933 65.5898 90.6599C64.6232 89.5933 62.7399 86.8099 62.8564 86.61C62.9065 86.5432 63.3398 86.2766 63.8231 85.9933C64.2898 85.7266 66.0565 84.71 67.7231 83.7433L70.7399 81.9933L71.3732 82.9266C72.2565 84.2766 74.1898 86.1266 75.3564 86.7433C78.7065 88.5099 83.3065 88.2599 85.5731 86.2266C86.5398 85.3433 86.9398 84.4266 86.9398 83.0765C86.9398 81.86 86.7898 81.3265 86.1565 80.4099C85.3398 79.2433 83.6732 78.2599 78.9398 76.21C73.5232 73.8766 71.1898 72.4266 69.0565 70.1266C67.8231 68.7932 66.6565 66.6599 66.1732 64.8766C65.7732 63.3933 65.6732 59.6766 65.9899 58.1766C67.1064 52.9432 71.0565 49.2932 76.7565 48.21C78.6064 47.86 82.9065 47.9933 84.7231 48.4432Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "leftArr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uF153",
    d: "M5.74219 21.875L26.25 2.59766L23.3789 0L0 21.875L23.3789 43.75L26.25 41.1523L5.74219 21.875Z",
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "rightArr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uF154",
    d: "M2.87109 0L0 2.59766L20.5078 21.875L0 41.1523L2.87109 43.75L26.25 21.875L2.87109 0Z",
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uF231",
    d: "M6.75 4.5L4.5 4.5L4.5 3.16406Q4.5 2.67188 4.67578 2.46094Q4.88672 2.25 5.55469 2.25L6.75 2.25L6.75 0L4.78125 0Q3.05859 0 2.32031 0.773438Q1.58203 1.51172 1.58203 2.98828L1.58203 4.5L0 4.5L0 6.75L1.58203 6.75L1.58203 13.5L4.5 13.5L4.5 6.75L6.46875 6.75L6.75 4.5Z",
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uF243",
    d: "M14.9062 3.375Q15.9609 2.60156 16.5938 1.61719Q15.7148 2.03906 14.625 2.14453Q15.2974 1.75736 15.6982 1.18122Q15.9889 0.763361 16.1367 0.246094Q15.0117 0.914062 13.957 1.08984Q13.3914 0.485252 12.696 0.216058Q12.1379 0 11.4961 0Q10.6899 0 10.0267 0.307914Q9.50414 0.550548 9.07031 0.984375Q8.63649 1.4182 8.39385 1.9408Q8.08594 2.604 8.08594 3.41016Q8.08594 3.9375 8.15625 4.18359Q6.01905 4.07849 4.27466 3.19649Q2.5183 2.30844 1.16016 0.632812Q0.835215 1.20771 0.741301 1.81815Q0.703125 2.06629 0.703125 2.32031Q0.703125 3.31823 1.13674 4.06405Q1.51276 4.7108 2.21484 5.16797Q1.44141 5.16797 0.667969 4.74609L0.667969 4.78125Q0.667969 5.40996 0.869889 5.96524Q1.06316 6.49672 1.44141 6.96094Q1.90446 7.48439 2.48281 7.78879Q2.91438 8.01593 3.41016 8.12109Q2.84766 8.26172 2.49609 8.26172Q2.28516 8.26172 1.86328 8.19141Q1.99304 8.60953 2.21741 8.96852Q2.54014 9.48488 3.05859 9.87891Q3.48047 10.1827 3.95094 10.3487Q4.46063 10.5286 5.02734 10.5469Q4.05578 11.3168 2.95039 11.6853Q1.93586 12.0234 0.808594 12.0234Q0.5625 12.0234 0 11.9531Q1.28726 12.7861 2.69684 13.1705Q3.90505 13.5 5.20312 13.5Q8.02737 13.5 10.1256 12.2658Q11.2922 11.5795 12.2344 10.5117Q14.0377 8.47113 14.6239 6.12627Q14.9062 4.99687 14.9062 3.79688L14.9062 3.375Z",
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "linked"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uF239",
    d: "M12.8598 0.0909302Q12.6552 0 12.4102 0L1.16016 0Q0.876007 0 0.638727 0.105458Q0.465005 0.182667 0.316406 0.316406Q0.194023 0.425192 0.118976 0.560275Q0 0.774433 0 1.05469L0 12.3398Q0 12.5034 0.0450069 12.6534Q0.125788 12.9227 0.351562 13.1484Q0.577336 13.3742 0.846608 13.455Q0.996631 13.5 1.16016 13.5L12.4102 13.5Q12.615 13.5 12.7916 13.4294Q13.009 13.3424 13.1836 13.1484Q13.3629 12.9492 13.4406 12.7161Q13.5 12.5379 13.5 12.3398L13.5 1.05469Q13.5 0.774433 13.381 0.560275Q13.306 0.425192 13.1836 0.316406Q13.0368 0.16962 12.8598 0.0909302ZM2.69572 4.1742Q2.60709 4.11881 2.53125 4.04297Q2.3887 3.8826 2.3184 3.69513Q2.25 3.51274 2.25 3.30469Q2.25 2.9709 2.40002 2.73087Q2.45541 2.64225 2.53125 2.56641Q2.67804 2.41962 2.85509 2.34093Q3.05968 2.25 3.30469 2.25Q3.58494 2.25 3.7991 2.36898Q3.93418 2.44402 4.04297 2.56641Q4.11881 2.64225 4.1742 2.73087Q4.32422 2.9709 4.32422 3.30469Q4.32422 3.47344 4.27359 3.62531Q4.19766 3.85313 4.00781 4.04297Q3.93197 4.11881 3.84334 4.1742Q3.60332 4.32422 3.26953 4.32422Q2.93574 4.32422 2.69572 4.1742ZM11.25 7.73438L11.25 11.25L9.31641 11.25L9.31641 7.94531Q9.31641 7.1182 8.91841 6.81701Q8.69049 6.64453 8.33203 6.64453Q8.02183 6.64453 7.79374 6.78139Q7.50483 6.95473 7.34766 7.34766Q7.27734 7.48828 7.27734 7.83984L7.27734 11.25L5.34375 11.25L5.34375 5.23828L7.27734 5.23828L7.27734 6.08203Q7.74185 5.43172 8.35979 5.21103Q8.67723 5.09766 9.03516 5.09766Q9.66418 5.09766 10.1353 5.37041Q10.4014 5.52449 10.6172 5.76562Q11.25 6.43359 11.25 7.73438ZM4.18359 5.23828L4.18359 11.25L2.25 11.25L2.25 5.23828L4.18359 5.23828Z",
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "instagram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 0L5 0C2.23859 0 0 2.23853 0 5L0 13C0 15.7615 2.23859 18 5 18L13 18C15.7614 18 18 15.7615 18 13L18 5C18 2.23853 15.7614 0 13 0ZM16.25 13C16.2445 14.7925 14.7926 16.2444 13 16.25L5 16.25C3.20734 16.2444 1.75549 14.7925 1.75 13L1.75 5C1.75549 3.20728 3.20734 1.75537 5 1.75L13 1.75C14.7926 1.75537 16.2445 3.20728 16.25 5L16.25 13ZM13.75 5.25C14.3023 5.25 14.75 4.80225 14.75 4.25C14.75 3.69775 14.3023 3.25 13.75 3.25C13.1977 3.25 12.75 3.69775 12.75 4.25C12.75 4.80225 13.1977 5.25 13.75 5.25ZM9 4.5C6.51471 4.5 4.5 6.51465 4.5 9C4.5 11.4854 6.51471 13.5 9 13.5C11.4853 13.5 13.5 11.4854 13.5 9C13.5027 7.80566 13.0294 6.65967 12.1849 5.81519C11.3404 4.9707 10.1943 4.49731 9 4.5ZM6.25 9C6.25 10.5188 7.4812 11.75 9 11.75C10.5188 11.75 11.75 10.5188 11.75 9C11.75 7.4812 10.5188 6.25 9 6.25C7.4812 6.25 6.25 7.4812 6.25 9Z",
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "telegram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0ZM13.5 5.25L11.25 13.5C11.0625 14.25 10.6875 14.4375 10.125 14.0625L7.875 12.375L6.75 13.4375C6.5625 13.625 6.375 13.6875 6.1875 13.6875L6.375 11.4375L12.1875 6.375C12.4688 6.14062 12.1406 6 11.8125 6.1875L5.0625 10.6875L2.8125 9.9375C2.0625 9.65625 2.0625 9.1875 2.90625 8.90625L12.9375 5.0625C13.5 4.875 14.0625 5.25 13.5 5.25Z",
    fill: "currentColor",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "hal"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.989
    },
    fill: "#000000",
    d: "M 368.5,480.5 C 385.93,441.313 403.597,402.313 421.5,363.5C 472.167,363.5 522.833,363.5 573.5,363.5C 608.766,282.963 644.6,202.63 681,122.5C 722.433,121.17 763.933,121.17 805.5,122.5C 715.833,321.833 626.167,521.167 536.5,720.5C 495.167,721.833 453.833,721.833 412.5,720.5C 448.371,640.592 484.371,560.759 520.5,481C 469.834,480.5 419.168,480.333 368.5,480.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#000000",
    d: "M 1063.5,364.5 C 1023.17,363.833 982.833,363.167 942.5,362.5C 940.929,356.77 938.596,351.437 935.5,346.5C 933.929,340.77 931.596,335.437 928.5,330.5C 926.929,324.77 924.596,319.437 921.5,314.5C 921.293,311.759 920.293,309.426 918.5,307.5C 917.958,304.088 916.625,301.088 914.5,298.5C 914.293,295.759 913.293,293.426 911.5,291.5C 909.929,285.77 907.596,280.437 904.5,275.5C 902.929,269.77 900.596,264.437 897.5,259.5C 897.293,256.759 896.293,254.426 894.5,252.5C 894.719,251.325 894.386,250.325 893.5,249.5C 892.893,249.624 892.56,249.957 892.5,250.5C 862.972,317.751 833.639,385.084 804.5,452.5C 802.952,452.821 802.285,453.821 802.5,455.5C 801.833,457.5 801.167,459.5 800.5,461.5C 798.952,461.821 798.285,462.821 798.5,464.5C 798.167,465.833 797.833,467.167 797.5,468.5C 795.952,468.821 795.285,469.821 795.5,471.5C 794.222,475.667 792.556,479.667 790.5,483.5C 788.461,484.911 787.461,486.911 787.5,489.5C 786.925,492.912 785.592,495.912 783.5,498.5C 760.071,549.77 737.404,601.437 715.5,653.5C 713.375,656.088 712.042,659.088 711.5,662.5C 702.885,682.062 694.551,701.729 686.5,721.5C 645.167,721.5 603.833,721.5 562.5,721.5C 651.541,521.747 740.874,322.081 830.5,122.5C 872.167,121.167 913.833,121.167 955.5,122.5C 991.7,203.107 1027.7,283.774 1063.5,364.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868685",
    d: "M 421.5,363.5 C 403.597,402.313 385.93,441.313 368.5,480.5C 332.953,560.597 297.12,640.597 261,720.5C 219.906,721.497 178.739,721.83 137.5,721.5C 226.541,521.747 315.874,322.081 405.5,122.5C 447.163,121.333 488.829,121.167 530.5,122C 494.024,202.451 457.69,282.951 421.5,363.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#797976",
    d: "M 892.5,250.5 C 892.56,249.957 892.893,249.624 893.5,249.5C 894.386,250.325 894.719,251.325 894.5,252.5C 893.833,251.833 893.167,251.167 892.5,250.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.533
    },
    fill: "#838382",
    d: "M 894.5,252.5 C 896.293,254.426 897.293,256.759 897.5,259.5C 895.707,257.574 894.707,255.241 894.5,252.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.714
    },
    fill: "#858584",
    d: "M 897.5,259.5 C 900.596,264.437 902.929,269.77 904.5,275.5C 901.404,270.563 899.071,265.23 897.5,259.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.729
    },
    fill: "#838382",
    d: "M 904.5,275.5 C 907.596,280.437 909.929,285.77 911.5,291.5C 908.404,286.563 906.071,281.23 904.5,275.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.514
    },
    fill: "#888887",
    d: "M 911.5,291.5 C 913.293,293.426 914.293,295.759 914.5,298.5C 912.707,296.574 911.707,294.241 911.5,291.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.694
    },
    fill: "#7f7f7e",
    d: "M 914.5,298.5 C 916.625,301.088 917.958,304.088 918.5,307.5C 916.375,304.912 915.042,301.912 914.5,298.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.529
    },
    fill: "#888887",
    d: "M 918.5,307.5 C 920.293,309.426 921.293,311.759 921.5,314.5C 919.707,312.574 918.707,310.241 918.5,307.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.478
    },
    fill: "#8c8c8c",
    d: "M 921.5,314.5 C 924.596,319.437 926.929,324.77 928.5,330.5C 925.404,325.563 923.071,320.23 921.5,314.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.486
    },
    fill: "#8c8c8b",
    d: "M 928.5,330.5 C 931.596,335.437 933.929,340.77 935.5,346.5C 932.404,341.563 930.071,336.23 928.5,330.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.51
    },
    fill: "#8a8a89",
    d: "M 935.5,346.5 C 938.596,351.437 940.929,356.77 942.5,362.5C 939.404,357.563 937.071,352.23 935.5,346.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868685",
    d: "M 942.5,362.5 C 982.833,363.167 1023.17,363.833 1063.5,364.5C 1116.42,483.5 1169.75,602.333 1223.5,721C 1181.91,720.844 1140.24,720.344 1098.5,719.5C 1081.69,682.711 1065.02,645.877 1048.5,609C 944.498,608.167 840.498,608.333 736.5,609.5C 729.479,624.27 722.479,638.936 715.5,653.5C 737.404,601.437 760.071,549.77 783.5,498.5C 783.5,499.5 783.5,500.5 783.5,501.5C 856.404,501.169 929.238,501.502 1002,502.5C 982.488,455.797 962.655,409.13 942.5,362.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.459
    },
    fill: "#878787",
    d: "M 804.5,452.5 C 804.068,453.71 803.401,454.71 802.5,455.5C 802.285,453.821 802.952,452.821 804.5,452.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.518
    },
    fill: "#7a7a79",
    d: "M 800.5,461.5 C 800.068,462.71 799.401,463.71 798.5,464.5C 798.285,462.821 798.952,461.821 800.5,461.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.471
    },
    fill: "#8e8e8d",
    d: "M 797.5,468.5 C 797.068,469.71 796.401,470.71 795.5,471.5C 795.285,469.821 795.952,468.821 797.5,468.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.475
    },
    fill: "#7f7f7e",
    d: "M 790.5,483.5 C 790.008,485.819 789.008,487.819 787.5,489.5C 787.461,486.911 788.461,484.911 790.5,483.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.475
    },
    fill: "#898988",
    d: "M 715.5,653.5 C 714.958,656.912 713.625,659.912 711.5,662.5C 712.042,659.088 713.375,656.088 715.5,653.5 Z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "live-preview"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5958"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "akar-icons:link-chain",
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "akar-icons:link-chain",
    width: 20,
    height: 20,
    fill: "#FFFFFF",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2866 8.71329C10.6041 8.03101 9.67847 7.64771 8.71338 7.64771C7.74817 7.64771 6.82263 8.03101 6.14001 8.71329L3.5658 11.2866C2.88318 11.9692 2.49976 12.8951 2.49976 13.8604C2.49976 14.8257 2.88318 15.7515 3.5658 16.4341C4.24841 17.1167 5.17419 17.5002 6.13965 17.5002C7.10498 17.5002 8.03076 17.1167 8.71338 16.4341L10 15.1475",
    stroke: "#2D2C2C",
    strokeOpacity: 1,
    strokeWidth: 1.666667,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.71338 11.2867C9.396 11.969 10.3215 12.3523 11.2867 12.3523C12.2518 12.3523 13.1775 11.969 13.86 11.2867L16.4342 8.71335C17.1168 8.03073 17.5002 7.10492 17.5002 6.13959C17.5002 5.17426 17.1168 4.24844 16.4342 3.56583C15.7516 2.88324 14.8258 2.49976 13.8605 2.49976C12.8951 2.49976 11.9694 2.88324 11.2867 3.56583L10 4.85251",
    stroke: "#2D2C2C",
    strokeOpacity: 1,
    strokeWidth: 1.666667,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "github"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5975"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "akar-icons:github-fill-2",
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "akar-icons:github-fill-2",
    width: 20,
    height: 20,
    fill: "#FFFFFF",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 0C4.47498 0 0 4.47501 0 10C0 14.425 2.86255 18.1625 6.83752 19.4875C7.33752 19.575 7.52502 19.275 7.52502 19.0125C7.52502 18.775 7.51245 17.9875 7.51245 17.15C5 17.6125 4.34998 16.5375 4.15002 15.975C4.03748 15.6875 3.55005 14.8 3.125 14.5625C2.77502 14.375 2.27502 13.9125 3.11255 13.9C3.90002 13.8875 4.46252 14.625 4.65002 14.925C5.55005 16.4375 6.98755 16.0125 7.5625 15.75C7.65002 15.1 7.91248 14.6625 8.19995 14.4125C5.97498 14.1625 3.65002 13.3 3.65002 9.47501C3.65002 8.38751 4.03748 7.48749 4.67505 6.78751C4.57495 6.53751 4.22498 5.51251 4.77502 4.13751C4.77502 4.13751 5.61255 3.875 7.52502 5.16251C8.32495 4.9375 9.17505 4.82501 10.025 4.82501C10.875 4.82501 11.725 4.9375 12.525 5.16251C14.4375 3.86249 15.275 4.13751 15.275 4.13751C15.825 5.51251 15.475 6.53751 15.375 6.78751C16.0125 7.48749 16.4 8.375 16.4 9.47501C16.4 13.3125 14.0625 14.1625 11.8375 14.4125C12.2 14.725 12.5125 15.325 12.5125 16.2625C12.5125 17.6 12.5 18.675 12.5 19.0125C12.5 19.275 12.6875 19.5875 13.1875 19.4875C15.1726 18.8173 16.8977 17.5414 18.1198 15.8395C19.3418 14.1375 19.9994 12.0952 20 10C20 4.47501 15.525 0 10 0Z",
    fill: "currentColor",
    fillOpacity: 1,
    fillRule: "evenodd"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "view-code"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5974"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "akar-icons:github-fill",
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "akar-icons:github-fill",
    width: 20,
    height: 20,
    fill: "#FFFFFF",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 0C4.47498 0 0 4.47501 0 10C0 14.425 2.86255 18.1625 6.83752 19.4875C7.33752 19.575 7.52502 19.275 7.52502 19.0125C7.52502 18.775 7.51245 17.9875 7.51245 17.15C5 17.6125 4.34998 16.5375 4.15002 15.975C4.03748 15.6875 3.55005 14.8 3.125 14.5625C2.77502 14.375 2.27502 13.9125 3.11255 13.9C3.90002 13.8875 4.46252 14.625 4.65002 14.925C5.55005 16.4375 6.98755 16.0125 7.5625 15.75C7.65002 15.1 7.91248 14.6625 8.19995 14.4125C5.97498 14.1625 3.65002 13.3 3.65002 9.47501C3.65002 8.38751 4.03748 7.48749 4.67505 6.78751C4.57495 6.53751 4.22498 5.51251 4.77502 4.13751C4.77502 4.13751 5.61255 3.875 7.52502 5.16251C8.32495 4.9375 9.17505 4.82501 10.025 4.82501C10.875 4.82501 11.725 4.9375 12.525 5.16251C14.4375 3.86249 15.275 4.13751 15.275 4.13751C15.825 5.51251 15.475 6.53751 15.375 6.78751C16.0125 7.48749 16.4 8.375 16.4 9.47501C16.4 13.3125 14.0625 14.1625 11.8375 14.4125C12.2 14.725 12.5125 15.325 12.5125 16.2625C12.5125 17.6 12.5 18.675 12.5 19.0125C12.5 19.275 12.6875 19.5875 13.1875 19.4875C15.1726 18.8173 16.8977 17.5414 18.1198 15.8395C19.3418 14.1375 19.9994 12.0952 20 10C20 4.47501 15.525 0 10 0Z",
    fill: "#2D2C2C",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrowGoTop"
  }, /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("path", {
    d: "M6.8 4.28L6.8 15L9.19 15L9.19 4.28L14.31 9.08L16 7.5L8 0L0 7.5L1.68 9.08L6.8 4.28Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSprite);
export default __webpack_public_path__ + "static/media/icons-sprite.6e5c029abc8c9855b3faef2f052a25ae.svg";
export { ForwardRef as ReactComponent };